import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/dex/dex-bg.webp")